import React from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "./ui/alert-dialog";
import { formatDate } from "../lib/api";
import { AlertTriangle } from "lucide-react";

/**
 * Warning shown before re-pushing a bill that was already pushed to RentFlow.
 * RentFlow dedupes by bill_id, so a re-push updates the existing record in place
 * (it does not create a duplicate) — but we still confirm to avoid accidents.
 */
export const RentflowRepushDialog = ({ open, onOpenChange, push, onConfirm }) => {
  const pushedAt = push?.pushed_at ? formatDate(push.pushed_at) : null;
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="rentflow-repush-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-4 w-4 text-amber-600" /> Re-push to RentFlow?
          </AlertDialogTitle>
          <AlertDialogDescription>
            This bill was already pushed to RentFlow{pushedAt ? ` on ${pushedAt}` : ""}. Re-pushing will
            update the existing record in RentFlow (matched by bill ID) — it won't create a duplicate,
            but any RentFlow-side edits to the toll data may be overwritten. Continue?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="rentflow-repush-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            className="bg-amber-600 hover:bg-amber-700"
            data-testid="rentflow-repush-confirm"
          >
            Re-push
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
